import { render, staticRenderFns } from "./StartPage.vue?vue&type=template&id=350bb220&scoped=true&lang=pug&"
import script from "./StartPage.vue?vue&type=script&lang=ts&"
export * from "./StartPage.vue?vue&type=script&lang=ts&"
import style0 from "./StartPage.vue?vue&type=style&index=0&id=350bb220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350bb220",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('350bb220')) {
      api.createRecord('350bb220', component.options)
    } else {
      api.reload('350bb220', component.options)
    }
    module.hot.accept("./StartPage.vue?vue&type=template&id=350bb220&scoped=true&lang=pug&", function () {
      api.rerender('350bb220', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/job-match/start-page/StartPage.vue"
export default component.exports